import { Box, Paper, Stack, Typography } from "@mui/material";

const AmountRow = ({ label, amount, isTotal = false, variant = "body2" }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    gap="16px"
    sx={{
      p: "12px 24px",
      borderBottom: "1px solid #E6E6E6",
      "&:last-of-type": { borderBottom: "none" },
    }}
  >
    <Typography variant={variant} fontWeight={isTotal ? 600 : 400}>
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={isTotal ? 600 : 400}>
      {amount}
    </Typography>
  </Stack>
);

export const FtiAmountBreakdown = ({ details, formatAmount }) => {
  // `category_amount` is a list of { title, value }, the API decides the categories and their titles
  const { category_amount = [], vat_amount = 0, total_amount = 0 } = details;
  // The API returns the VAT inclusive total, so the value before VAT is derived from it
  const subtotal = total_amount - vat_amount;

  return (
    <Paper sx={{ overflow: "hidden" }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        gap="16px"
        sx={{ p: "12px 24px", bgcolor: "#F5F5F5" }}
      >
        <Typography variant="body2" fontWeight={600}>
          DESCRIPTION/รายการ
        </Typography>
        <Typography variant="body2" fontWeight={600}>
          AMOUNT (THB)/จำนวนเงิน (บาท)
        </Typography>
      </Stack>

      <Box sx={{ borderBottom: "1px solid #E6E6E6" }}>
        {category_amount.map(({ title, value }) => (
          <AmountRow key={title} label={title} amount={formatAmount(value)} />
        ))}
      </Box>

      <Stack direction="row">
        <Box flex={1} display={{ xs: "none", md: "block" }} />
        <Box
          width={{ xs: "100%", md: "45%" }}
          sx={{ borderLeft: { md: "1px solid #E6E6E6" } }}
        >
          <AmountRow
            variant="caption"
            label="Total value of goods and services/มูลค่าสินค้าและบริการ"
            amount={formatAmount(subtotal)}
          />
          <AmountRow
            variant="caption"
            label="Value Added Tax (VAT)/ภาษีมูลค่าเพิ่ม"
            amount={formatAmount(vat_amount)}
          />
          <AmountRow
            isTotal
            label="Grand Total/รวมเงินทั้งสิ้น"
            amount={formatAmount(total_amount)}
          />
        </Box>
      </Stack>
    </Paper>
  );
};
